import React, { useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from '../../services/Navigation';
import UserAccount from '../../services/UserAccount';
import Constants from '../../submodules/logictry_config/constants';
import LoginPage from '../../containers/LoginPage/index';
import RegisterPage from '../../containers/RegisterPage/index';
import LogicBaseUserPage from '../../containers/LogicBaseUserPage/index';
import LogicBaseAppPage from '../../containers/LogicBaseAppPage/index';
import TreeAnswerPage from '../../containers/TreeAnswerPage/index';
import LogicBaseMapPage from '../../containers/LogicBaseMapPage/index';
import ResetPasswordPage from '../../containers/ResetPasswordPage/index';
import SettingsPage from '../../containers/SettingsPage/index';
import AppLandingPage from '../../containers/AppLandingPage/index';
import LogicBaseLeaderboard from '../../containers/LogicBaseLeaderboard/index';
import LogicBaseNotificationPage from '../../containers/LogicBaseNotificationPage';
import LogicBaseFollowPage from '../../containers/LogicBaseFollowPage';
import LogicBaseAnalyticsPage from '../../containers/LogicBaseAnalyticsPage';
import LogicBaseCollectionsPage from '../../containers/LogicBaseCollectionsPage';
import LogicBaseCollectionPage from '../../containers/LogicBaseCollectionPage';
import LogicBaseDrawer from '../../components/LogicBaseDrawer';
import WindowSize from '../../services/WindowSize';
import DrawerService from '../../services/Drawer';
import NotFoundPage from '../../containers/NotFoundPage';
import LoginToViewPage from '../../containers/LoginToViewPage';
import LogicBaseExpertsPage from '../../containers/LogicBaseExpertsPage';
import Legal from './legalroutes';

const Wrapper = styled.div`
  inset: 0;
  overflow: hidden;
  > div:nth-child(2) {
    background: white;
  }
  > div:nth-child(3) {
    position: fixed;
    top: 0px;
    left: -240px;
    bottom: 0px;
    width: 240px;
  }
  > div:nth-child(1) {
    inset: 0;
  }
`;
const DrawerWrapper = styled.div`
  z-index: 3;
`;

function LogicBaseRoutes() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  Navigation.useNavigate = useNavigate();
  Navigation.location = useLocation();
  const { isWidget } = Constants;

  if (isWidget) return (
    <Routes key={window.location.href}>
      <Route path="collections/:id" element={<LogicBaseCollectionPage />} />
      <Route path="/apps/:id" element={<TreeAnswerPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );

  const specialRoute = ['login', 'register', 'reset-password'].includes(Navigation.currentLocation[1]);
  if (specialRoute) {
    if (UserAccount.isLoggedIn) setTimeout(() => { Navigation.replace(Navigation.home); });
  }

  const loggedIn = (UserAccount.state === 'loggedIn');
  const { isDevAccount } = UserAccount;
  const { mobile } = WindowSize;
  const { open } = DrawerService;
  const mobileAbsolute = ['login', 'register', 'reset-password', 'legal'].includes(Navigation.currentLocation[1]);
  return (
    <Wrapper
      key={`${window.location.pathname}${window.location.search}${JSON.stringify(Navigation.location.state)}`}
      style={{ position: (mobile && !mobileAbsolute) ? 'relative' : 'absolute' }}
    >
      <div style={{ position: (mobile && !mobileAbsolute) ? 'relative' : 'absolute' }}>
        <Routes>
          <Route path="/" element={<LogicBaseCollectionsPage />} />
          <Route path="account" element={loggedIn && <LogicBaseUserPage /> || <LoginToViewPage />} />
          <Route path="account/notifications" element={loggedIn && <LogicBaseNotificationPage /> || <LoginToViewPage />} />
          <Route path="account/settings" element={loggedIn && <SettingsPage /> || <LoginToViewPage />} />
          <Route path="account/follow-requests" element={loggedIn && <LogicBaseFollowPage /> || <LoginToViewPage />} />
          {isDevAccount && <Route path="analytics" element={<LogicBaseAnalyticsPage />} />}
          <Route path="apps/:id" element={<LogicBaseAppPage />} />
          <Route path="legal" element={<AppLandingPage app="5f38503f916d230a6bdf43a2" />} />
          {Legal.map(({ url, app }) => (
            <Route key={url} path={`legal/${url}`} element={<AppLandingPage app={app} />} />
          ))}
          <Route path="experts" element={<LogicBaseExpertsPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="map" element={<LogicBaseMapPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="collections" element={<LogicBaseCollectionsPage />} />
          <Route path="collections/:id" element={<LogicBaseCollectionPage />} />
          <Route path="users" element={<LogicBaseLeaderboard />} />
          <Route path="users/:id" element={<LogicBaseUserPage />} />
          {pathname.startsWith('/@') && <Route path=":id" element={<LogicBaseUserPage />} />}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      {open && <DrawerWrapper style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)' }} onClick={() => DrawerService.toggle()}></DrawerWrapper> || <div></div>}
      <DrawerWrapper style={{ transform: open ? 'translateX(240px)' : 'translateX(0px)' }}>
        <LogicBaseDrawer />
      </DrawerWrapper>
    </Wrapper>
  );
}
 
 export default LogicBaseRoutes;
 